import { __decorate } from "tslib";
import { fetchBlobFromCache, fetchBlobsFromCache } from '@/utilities/fetchFromCache';
import _ from 'lodash';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let Blobs = class Blobs extends VuexModule {
    constructor() {
        super(...arguments);
        this.handbookBlobs = {};
        this.starshipBlobs = {};
        this.variantRuleBlobs = [];
        this.expandedContentBlobs = [];
        this.monsterBlobs = {};
        this.hivesBlobs = {};
        this.creditsBlob = '';
        this.cachedVersions = {
            handbookBlobs: 0,
            starshipBlobs: 0,
            variantRulesBlobs: 0,
            monsterBlobs: 0,
            hivesBlobs: 0,
            creditsBlob: 0
        };
    }
    async fetchHandbookBlob(chapter) {
        const { blobs: handbookBlobs, cachedVersions } = await fetchBlobFromCache(this, 'handbookBlobs', chapter, 'player-handbook-rules', 'PlayerHandbookRule');
        return { handbookBlobs, cachedVersions };
    }
    async fetchStarshipBlob(chapter) {
        const { blobs: starshipBlobs, cachedVersions } = await fetchBlobFromCache(this, 'starshipBlobs', chapter, 'starships-rules', 'StarshipRule');
        return { starshipBlobs, cachedVersions };
    }
    async fetchVariantRuleBlobs() {
        const { data, cachedVersions } = await fetchBlobsFromCache(this, 'variantRuleBlobs', 'variant-rules', 'VariantRule');
        return {
            variantRuleBlobs: data.map((variantRuleBlob) => _.pick(variantRuleBlob, ['chapterName', 'contentMarkdown'])),
            cachedVersions
        };
    }
    async fetchExpandedContentBlobs() {
        const { data, cachedVersions } = await fetchBlobsFromCache(this, 'expandedContentBlobs', 'expanded-content', 'ExpandedContent');
        return {
            expandedContentBlobs: data.map((expandedContentBlob) => _.pick(expandedContentBlob, ['chapterName', 'contentMarkdown'])),
            cachedVersions
        };
    }
    async fetchHivesBlob(chapter) {
        const { blobs: hivesBlobs, cachedVersions } = await fetchBlobFromCache(this, 'hivesBlobs', chapter, 'wretched-hives-rules', 'WretchedHivesRule');
        return { hivesBlobs, cachedVersions };
    }
    async fetchCreditsBlob() {
        const { data: creditsBlob, cachedVersions } = await fetchBlobsFromCache(this, 'creditsBlob', 'credits', 'Credit');
        return { creditsBlob, cachedVersions };
    }
};
__decorate([
    MutationAction({ mutate: ['handbookBlobs', 'cachedVersions'] })
], Blobs.prototype, "fetchHandbookBlob", null);
__decorate([
    MutationAction({ mutate: ['starshipBlobs', 'cachedVersions'] })
], Blobs.prototype, "fetchStarshipBlob", null);
__decorate([
    MutationAction({ mutate: ['variantRuleBlobs', 'cachedVersions'] })
], Blobs.prototype, "fetchVariantRuleBlobs", null);
__decorate([
    MutationAction({ mutate: ['expandedContentBlobs', 'cachedVersions'] })
], Blobs.prototype, "fetchExpandedContentBlobs", null);
__decorate([
    MutationAction({ mutate: ['hivesBlobs', 'cachedVersions'] })
], Blobs.prototype, "fetchHivesBlob", null);
__decorate([
    MutationAction({ mutate: ['creditsBlob', 'cachedVersions'] })
], Blobs.prototype, "fetchCreditsBlob", null);
Blobs = __decorate([
    Module({ namespaced: true, name: 'blobs' })
], Blobs);
export default Blobs;
